export const DEFAULT_ITEM_CAROUSEL_CONFIG = {
    sm: {
        width: '242px',
    },
    md: {
        width: '255px',
    },
    lg: {
        width: '546px',
    },
};
